// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__J1LZ1","footer":"Contact_footer__2dhjZ","text":"Contact_text__Wq-3f","links":"Contact_links__jdYkD","link":"Contact_link__aB+2C"};